import { forwardRef } from 'react';

import { mergeClasses } from '@/utils';

import { ITextarea } from './Textarea.interfaces';

const Textarea = forwardRef<HTMLTextAreaElement, ITextarea>(
  ({ className, label, error, required, resize = 'resize-none', ...props }, ref) => {
    return (
      <div className={mergeClasses('flex flex-col gap-1.5 border-neutral-n4 w-full', className)}>
        {label && (
          <label className="text-sm font-semibold text-neutral-n9">
            {label}
            {required && <span className="ml-1 text-semantic-error-base">*</span>}
          </label>
        )}

        <textarea
          ref={ref}
          data-slot="textarea"
          className={mergeClasses(
            'p-base w-full rounded-lg border border-neutral-n4 bg-white text-body-sm font-medium text-brand-primary-darkest outline-none',
            'placeholder:text-neutral-n6 selection:bg-primary selection:text-primary-foreground',
            'focus-visible:border-brand-primary-base',
            'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-neutral-n2 disabled:border-neutral-n4',
            error && '!border-semantic-error-base',
            resize,
          )}
          {...props}
        />

        {error && <p className="text-xs text-semantic-error-base">{error}</p>}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';

export default Textarea;
